import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import insstagramIcon from "/src/images/icon/sns-instagram-bk.svg"
// import logoUri from "/src/images/icon/logo.png"

const logoUri = json.header.logoUri
const siteMetaData = json.siteMetadata
const footer = json.footer
const pageConstruct = json.pageConstruct
let pageConstructAddition = pageConstruct.concat()

const Component = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header>
      <h1>
        <Link to="/" className={style.logo}>
          <img
            src={logoUri}
            alt={siteMetaData.title}
            style={{ objectFit: "contain" }}
          />
        </Link>
      </h1>
      <nav className={style.nav}>
        <ul className={style.nav_list}>
          <li className={style.nav_item}>
            <Link to="/" className={style.hover}>HOME</Link>
          </li>
          <li className={style.nav_item}>
            <Link to={getPathFromTemplateType(4)} className={style.hover}>NEWS</Link>
          </li>
          <li className={style.nav_item}>
            <Link to="#">ABOUT</Link>
            <ul className={style.sub_nav_list}>
              <li className={style.sub_nav_item}>
                <Link to="/about-charmanvie">CHARMANVIE</Link>
              </li>
              <li className={style.sub_nav_item}>
                <Link to="/about-donamarie">DONA MARIE</Link>
              </li>
            </ul>
          </li>
          <li className={style.nav_item}>
            <Link to="#">PRODUCT</Link>
            <ul className={style.sub_nav_list}>
              <li className={style.sub_nav_item}>
                <Link to="/product-charmanvie">CHARMANVIE</Link>
              </li>
              <li className={style.sub_nav_item}>
                <Link to="/product-donamarie">DONA MARIE</Link>
              </li>
            </ul>
          </li>
          <li className={style.nav_item}>
            <Link to="/collection" className={style.hover}>COLLECTIONS</Link>
          </li>
          <li className={style.nav_item}>
            <Link to="https://www.dona-marie.co.jp/index.html" target="_blank" className={style.hover}>ONLINE SHOP</Link>
          </li>
          <li className={style.nav_item}>
            <Link to={getPathFromTemplateType(6)} className={style.hover}>CONTACT</Link>
          </li>
          <li className={style.nav_item}>
            <Link to="https://www.instagram.com/donamarie_official/" target="_blank"><img src={insstagramIcon} alt="instagram"/></Link>
          </li>
        </ul>
      </nav>
      
      <button
        className={style.menu}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {!isOpen ? (
          <StaticImage
            src="../../images/icon/menu-open.svg"
            placeholder="none"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            style={{width: "20px"}}
            alt="開く"
          />
        ) : null}
      </button>
      {isOpen ? (
        <div className={style.sp_menu}>
          <button
            className={style.close_btn}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <StaticImage
              src="../../images/icon/menu-close.svg"
              placeholder="none"
              loading="eager"
              formats={["auto", "webp", "avif"]}
              style={{width: "20px"}}
              alt="閉じる"
            />
          </button>
          <nav className={style.sp_nav}>
            <ul className={style.sp_nav_list}>
              <li className={style.sp_nav_item}>
                <Link to="/">HOME</Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to={getPathFromTemplateType(4)}>NEWS</Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to="#">ABOUT</Link>
                <ul className={style.sp_sub_nav_list}>
                  <li className={style.sp_sub_nav_item}>
                    <Link to="/about-charmanvie">- CHARMANVIE</Link>
                  </li>
                  <li className={style.sp_sub_nav_item}>
                    <Link to="/about-donamarie">- DONA MARIE</Link>
                  </li>
                </ul>
              </li>
              <li className={style.sp_nav_item}>
                <Link to="#">PRODUCT</Link>
                <ul className={style.sp_sub_nav_list}>
                  <li className={style.sp_sub_nav_item}>
                    <Link to="/product-charmanvie">- CHARMANVIE</Link>
                  </li>
                  <li className={style.sp_sub_nav_item}>
                    <Link to="/product-donamarie">- DONA MARIE</Link>
                  </li>
                </ul>
              </li>
              <li className={style.sp_nav_item}>
                <Link to="/collection">COLLECTIONS</Link>
              </li>
              <li className={style.sp_nav_item}>
                <Link to="https://www.dona-marie.co.jp/index.html" target="_blank">ONLINE SHOP</Link>
              </li>
              <li className={`${style.sp_nav_item} ${style.contact}`}>
                <Link to={getPathFromTemplateType(6)}>CONTACT</Link>
              </li>
            </ul>

            {/* <div className={style.sns_link}>
              {footer.facebookUrl && (
                <Link to={footer.facebookUrl}>
                  <StaticImage
                    src="../../images/icon/sns-facebook-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="facebook"
                  />
                </Link>
              )}
              {footer.instagramUrl && (
                <Link to={footer.instagramUrl}>
                  <StaticImage
                    src="../../images/icon/sns-instagram-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="instagram"
                  />
                </Link>
              )}
              {footer.lineUrl && (
                <Link to={footer.lineUrl}>
                  <StaticImage
                    src="../../images/icon/sns-line-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="line"
                  />
                </Link>
              )}
              {footer.xUrl && (
                <Link to={footer.xUrl}>
                  <StaticImage
                    src="../../images/icon/sns-x-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="x"
                  />
                </Link>
              )}
              {footer.blogUrl && (
                <Link to={footer.blogUrl}>
                  <StaticImage
                    src="../../images/icon/sns-blog-wh.svg"
                    placeholder="none"
                    loading="eager"
                    formats={["auto", "webp", "avif"]}
                    alt="blog"
                  />
                </Link>
              )}
            </div> */}
          </nav>
        </div>
      ) : null}
    </header>
  )
}

export default Component
